import { AbstractQuery } from 'src/models/query';

export class TaskQuery extends AbstractQuery {
	apiVersion = 2;
	name = 'IFS_Desktop_Query_Queries_Task_GetTheDetailsForTheTaskQuery';
	sort = [];

	constructor(aggregateId: string) {
		super();
		this.parameters.push({ aggregateId: aggregateId });
	}
}

export class GetLinkedTasksForActivityQuery extends AbstractQuery {
	protected cacheable = false;
	readonly name = 'IFS_DesktopModule_Task_Query_Queries_GetLinkedTasksForActivityQuery';
	protected subscribeForUpdates = true;

	constructor(
		originAggregateId: string,
		private readonly subscriptionContextIdentifier?: string
	) {
		super();
		this.parameters.push({ originAggregateId });
	}

	override uniqueQueryIdentifier(): string {
		if (this.subscriptionContextIdentifier === undefined) {
			return super.uniqueQueryIdentifier();
		}

		// QueryStore unsubscribe is identifier-wide, so each mounted header must own an isolated subscription.
		return this.createStableIdentifier({
			subscriptionContextIdentifier: this.subscriptionContextIdentifier,
		});
	}
}
